$(function () {
  $('.HeroSlider-container').flickity({
    cellSelector: '.HeroSlider-slide',
    autoPlay: 4500,
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    groupCells: 1,
    wrapAround: true,
    setGallerySize: false,
    friction: 0.7,
    cellAlign: 'center'
  });
});